/*
 * Where: src/features/top/components/ReadingStatusSection.js
 * What: Reading/loading display section for top page.
 * Why: Show task 2 waiting and communicating states in the UI.
 */
import React from 'react';

function ReadingStatusSection({
    statusCopy,
    primaryLabel,
    lastReadUid,
    lastReadSource,
    citizenSupport,
    canShowSupportList,
    readError,
    isLoading,
    isPrimaryDisabled,
    canCompleteForDevelopment,
    onStartReading,
    onCompleteForDevelopment,
}) {
    return (
        <section className="section-block reading-section">
            <h2>読み取り状態</h2>
            <div className="reading-state-card">
                <div>
                    <p className="reading-badge">{statusCopy.badge}</p>
                    <h3>{statusCopy.title}</h3>
                    <p className="reading-description">{statusCopy.detail}</p>
                </div>
                {isLoading ? (
                    <span className="reading-spinner" aria-hidden="true" />
                ) : (
                    <span className="reading-chip">確認専用</span>
                )}
            </div>
            <div className="reading-actions">
                <button
                    className="solid-action"
                    type="button"
                    onClick={onStartReading}
                    disabled={isPrimaryDisabled}
                >
                    {primaryLabel}
                </button>
                {canCompleteForDevelopment ? (
                    <button
                        className="outline-action"
                        type="button"
                        onClick={onCompleteForDevelopment}
                    >
                        開発用: 読み取り完了として扱う
                    </button>
                ) : null}
            </div>
            {lastReadUid ? (
                <p className="reading-meta">
                    最終読み取りUID: {lastReadUid}
                    {lastReadSource === 'development' ? '（開発用ボタン）' : '（実機読み取り）'}
                </p>
            ) : null}
            {citizenSupport ? (
                <p className="reading-meta">
                    紐付け対象者: {citizenSupport.name}
                </p>
            ) : null}
            {readError ? (
                <p className="reading-error" role="alert">
                    {readError}
                </p>
            ) : null}
            {canShowSupportList && citizenSupport ? (
                <div className="support-result-block">
                    <h3>該当支援</h3>
                    該当支援件数: {citizenSupport.can_use_support.length}
                    <table className="support-result-table" aria-label="該当支援一覧">
                        <thead>
                            <tr>
                                <th scope="col">id</th>
                                <th scope="col">名称</th>
                                <th scope="col">支援内容</th>

                            </tr>
                        </thead>
                        <tbody>
                            {citizenSupport.can_use_support.map((support) => (
                                <tr key={support.support_id}>
                                    <td>{support.support_id}</td>
                                    <td>{support.support_name}</td>
                                    <td>{support.support_content}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : null}
            {/* <p className="reading-note">
                本サービスは受給候補の確認専用です。申請処理は行いません。実機読み取りは拡張機能連携が必要です。
            </p> */}
        </section>
    );
}

export default ReadingStatusSection;
